import classNames from 'classnames';
import React from 'react';
import { withNativeProps } from '../../utils/native-props';
var classPrefix = "adm-badge";
export var dot = React.createElement(React.Fragment, null);
export var Badge = function Badge(props) {
  var content = props.content,
      color = props.color,
      children = props.children;
  var isDot = content === dot;
  var badgeCls = classNames(classPrefix, !!children && "".concat(classPrefix, "-fixed"), isDot && "".concat(classPrefix, "-dot"), props.bordered && "".concat(classPrefix, "-bordered"));
  var element = content || content === 0 ? withNativeProps(props, React.createElement("div", {
    className: badgeCls,
    style: {
      '--color': color
    }
  }, !isDot && React.createElement("div", {
    className: "".concat(classPrefix, "-content")
  }, content))) : null;
  return children ? React.createElement("div", {
    className: classNames("".concat(classPrefix, "-wrapper"), props.wrapperClassName),
    style: props.wrapperStyle
  }, children, element) : element;
};